var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.313 12h4.374M11.5 14.188V9.811",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.5a.5.5 0 00-.5-.5h-2A3.5 3.5 0 002 12.5v.5a1.5 1.5 0 001.5 1.5h4a.5.5 0 000-1h-4A.5.5 0 013 13v-.5A2.5 2.5 0 015.5 10h2a.5.5 0 00.5-.5z",
    fill: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5,
    r: 2.5,
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan7.1c462e47.svg";
export { SvgTongyongRenyuan7 as ReactComponent };